<script>
import BScroll from 'better-scroll'
import { BROWSER_TIME } from 'base/config'

export default {
  props: {
    probeType: {
      // 缓慢or快速可监听到
      type: Number,
      default: 1
    },
    click: {
      type: Boolean,
      default: true
    },
    data: [Array, Object],
    // 是否监听滚动事件
    listenScroll: {
      type: Boolean,
      default: false
    },
    pullup: {
      type: Boolean,
      default: false
    },
    eventPassthrough: {
      type: String,
      default: ''
    },
    scrollX: {
      type: Boolean,
      default: false
    },
    bounce: {
      type: Boolean,
      default: true
    }
  },
  watch: {
    data() {
      // data 数据变化
      setTimeout(() => {
        this.$emit('loadDone')
        this.refresh()
      }, BROWSER_TIME)
    }
  },
  mounted() {
    setTimeout(() => {
      this._initScroll()
    }, BROWSER_TIME)
  },
  methods: {
    _initScroll() {
      if (!this.$refs.wrapper) return
      this.scroll = new BScroll(this.$refs.wrapper, {
        probeType: this.probeType,
        click: this.click,
        scrollX: this.scrollX,
        scrollY: !this.scrollX,
        bounce: this.bounce,
        eventPassthrough: this.eventPassthrough
      })

      if (this.listenScroll) {
        // scroll 内 this 指向 scroll
        this.scroll.on('scroll', pos => {
          this.$emit('scroll', pos, this.scroll.maxScrollY)
        })
      }

      // 是否派发顶部下拉事件，用于下拉刷新
      if (this.pullup) {
        this.scroll.on('scrollEnd', () => {
          // 滚动到底部
          if (this.scroll.y <= this.scroll.maxScrollY + 50) {
            this.$emit('scrollToEnd')
          }
        })
      }
    },
    enable() {
      this.scroll && this.scroll.enable()
    },
    disable() {
      this.scroll && this.scroll.disable()
    },
    refresh() {
      this.scroll && this.scroll.refresh()
    },
    scrollTo() {
      // 会传入参数，所以用apply
      this.scroll && this.scroll.scrollTo.apply(this.scroll, arguments)
    },
    scrollToElement() {
      this.scroll && this.scroll.scrollToElement.apply(this.scroll, arguments)
    }
  }
}
</script>

<template>
  <div ref="wrapper">
    <slot />
  </div>
</template>
